import { render } from "./ReportDetail.vue?vue&type=template&id=21f47b17"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"

import "./ReportDetail.vue?vue&type=style&index=0&id=21f47b17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__